var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipsis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3.84,
    height: 16,
    viewBox: "0 0 3.84 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2f353a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.92,62.08A1.92,1.92,0,1,1,16,64,1.92,1.92,0,0,1,17.92,62.08ZM16,57.92A1.92,1.92,0,1,0,17.92,56,1.92,1.92,0,0,0,16,57.92Zm0,12.16a1.92,1.92,0,1,0,1.92-1.92A1.92,1.92,0,0,0,16,70.08Z",
    transform: "translate(-16 -56)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsis);
export default __webpack_public_path__ + "static/media/ellipsis.6c4c7b777db885f51276f94b24bea13b.svg";
export { ForwardRef as ReactComponent };